module.exports = __webpack_public_path__ + "img/Hummingbirds_3_MockedUp.923c3afd.jpg";